import { useEffect, useMemo, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { UiComponents, defaultLogo } from "@simulanisindia/ui";
import { FilterIcon } from "../../Icons";
import { removeDuplicatesByKey, toggleArrayByObject } from "../../utils/general";
import {
  ALL,
  AR_CONTENT_TAB,
  RESOURCE_APPLICATION_TAB,
  RESOURCE_ENVIRONMENT_TAB,
  RESOURCE_MODULE_TAB,
  RESOURCE_SKILL_SCHOOL_TAB,
  RESOURCE_SKILL_STREAM_TAB,
} from "../../constant/constants";
import NoDataFound from "../../components/NoDataFound";
import ResourceManagementSkelton from "../../components/Skeleton/ResourceManagement";
import ResourceTabComponent from "./ResourceMobile/ResourceTabComponent";

const {SearchBar, SimCheckBox } = UiComponents;

const ResourceSection = ({
  renderList,
  allTabResources,
  hasMore,
  loading,
  search,
  setSearch,
  selectedResource,
  setSelectedResource,
  openFilter,
  activeTab,
  loadMoreData,
  checkedFilterItem,
  checkBoxAll,
  setCheckBoxAll,
  selectCheckBoxAllClicked,
  isMobileView
}) => {
  const [resourceData, setResourceData] = useState([]);

  const handleCheckboxChange = (e, id_link, type, data) => {
    let toggleObject = toggleArrayByObject(selectedResource[type], data);

    setSelectedResource((pre) => ({
      ...pre,
      [type]: toggleObject,
    }));

    if (!e.target.checked) {
      setCheckBoxAll(pre => ({
        ...pre,
        [ALL]: false,
        [id_link]: false,
      }));
    }
  };

  useEffect(() => {
    if (selectCheckBoxAllClicked) {
      const { applicationTab, ...othersTabList } = allTabResources;
      let othersTabListData = Object.values(othersTabList).flat(Infinity)
      setSelectedResource({
        application: applicationTab.map(item => ({ id: item.id, name: item.title, avatar: item.icon })),
        module: othersTabListData.map(item => ({ id: item.id, name: item.title, avatar: item.icon }))
      });
    } else {
      setSelectedResource({
        application: [],
        module: []
      });
    }
  }, [selectCheckBoxAllClicked]);


  useEffect(() => {
    const resources = {
      [RESOURCE_APPLICATION_TAB]: {
        title: "Applications",
        list: renderList,
        id_link: RESOURCE_APPLICATION_TAB,
        type: "application",
        noFilter: false,
        hasMore: hasMore,
      },
      [RESOURCE_MODULE_TAB]: {
        title: "XR Modules",
        list: renderList,
        id_link: RESOURCE_MODULE_TAB,
        type: "module",
        noFilter: false,
        hasMore: hasMore,
      },
      [RESOURCE_ENVIRONMENT_TAB]: {
        title: "Environments",
        list: renderList,
        id_link: RESOURCE_ENVIRONMENT_TAB,
        type: "module",
        noFilter: false,
        hasMore: hasMore,
      },
      [RESOURCE_SKILL_STREAM_TAB]: {
        title: "Skill Stream",
        list: renderList,
        id_link: RESOURCE_SKILL_STREAM_TAB,
        type: "module",
        noFilter: false,
        hasMore: hasMore
      },
      [RESOURCE_SKILL_SCHOOL_TAB]: {
        title: "Skill School",
        list: renderList,
        id_link: RESOURCE_SKILL_SCHOOL_TAB,
        type: "module",
        noFilter: false,
        hasMore: hasMore
      },
      [AR_CONTENT_TAB]: {
        title: "AR Content",
        list: renderList,
        id_link: AR_CONTENT_TAB,
        type: "module",
        noFilter: false,
        hasMore: hasMore
      },
    };

    setResourceData(resources);
  }, [activeTab, hasMore, renderList]);

  function checkAndSetAll(inputObject) {
    const { all, ...otherKeys } = inputObject;
    let updatedAllKeyValue = Object.values(otherKeys).every(e => e == true);
    setCheckBoxAll({
      ...otherKeys,
      [ALL]: updatedAllKeyValue,
    });
  }

  const handleSelectCheckbox = (type, e) => {
    let allCheckbox = { ...checkBoxAll, [activeTab]: !e };
    checkAndSetAll(allCheckbox);
    let currentTabList = renderList.map(item => ({ id: item.id, name: item.title, avatar: item.icon }))
    let alreadySelected = selectedResource[type];

    let uniqueSelected;
    if (!e) {
      uniqueSelected = removeDuplicatesByKey([...currentTabList, ...alreadySelected], "id");
    } else {
      let filteredSelected = alreadySelected.filter(selItem => !currentTabList.some(listItem => listItem.id === selItem.id));
      uniqueSelected = removeDuplicatesByKey([...filteredSelected], "id");
    };

    setSelectedResource((pre) => ({
      ...pre,
      [type]: uniqueSelected,
    }));
  }

  const activeTabData = useMemo(() => resourceData[activeTab] ? [resourceData[activeTab]] : [], [resourceData, activeTab]);

  return (
    <>
      <div className="resource-content">
        {activeTabData && Object.entries(activeTabData).map(([tab, data]) => {

          const { title, list, id_link, noFilter, type, hasMore } = data;

          return (
            <>
            {!isMobileView ?
              <section key={id_link} id={id_link}>
                <div className="carddata colorborder mb-0">
                  
                  <div className="applicationsheader">
                    <div>
                      <div className=" d-flex gap-2">
                        {renderList.length > 0 && <SimCheckBox checked={checkBoxAll[activeTab]} onChange={(e) => handleSelectCheckbox(type, checkBoxAll[activeTab])} />}
                        <h6 className="card-heading">{title}</h6>
                      </div>
                      <p className="card-detail">Select the {title} you want to assign to a group and user.</p>
                    </div>

                    <div className="search-parent">
                      <div className="searchwithborder search-bar">
                        <SearchBar
                          onClick={() => { }}
                          placeholder="Search..."
                          value={search}
                          onChange={setSearch}
                        />
                      </div>
                      {!noFilter && (
                        <div className="filterbtn" onClick={() => openFilter(id_link)}>
                          <div className="btninadjust">
                            <FilterIcon />
                            {(checkedFilterItem[activeTab] || []).length > 0 && <span className="filter-active-span">{""}</span>}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  
                  <div className="listdata scrollable-container" id="scrollableDivResources">
                    {loading ? (
                      <ResourceManagementSkelton length="4" width={activeTab === RESOURCE_APPLICATION_TAB ? "50px" : "70px"} circle={activeTab === RESOURCE_APPLICATION_TAB ? true : false} />
                    ) : list?.length > 0 ? (
                      <InfiniteScroll
                        scrollThreshold={0.7}
                        dataLength={list.length}
                        next={() => loadMoreData()}
                        hasMore={hasMore}
                        loader={<ResourceManagementSkelton length="4" width={activeTab === RESOURCE_APPLICATION_TAB ? "50px" : "70px"} circle={activeTab === RESOURCE_APPLICATION_TAB ? true : false} />}
                        scrollableTarget="scrollableDivResources"
                      >

                        <>
                          {list?.map((item, index) => {
                            return (
                              <div className="modulelist" key={item.id}>
                                <div className="mcontewrap">
                                  <SimCheckBox
                                    checked={selectedResource[type].find((value) => value.id === item.id) ? true : false}
                                    onChange={(e) => handleCheckboxChange(e, id_link, type, { id: item.id, name: item.title, avatar: item.icon })}
                                    id={item.id}
                                  />
                                  <div className={id_link === RESOURCE_APPLICATION_TAB ? "applicationthumb" : ""}>
                                    <img src={item.icon || defaultLogo} alt="" referrerPolicy="no-referrer" className={item.icon === defaultLogo && id_link !== RESOURCE_APPLICATION_TAB ? "resource-default-logo" : ""} />
                                  </div>
                                  <div>
                                    <h6>{item.title}</h6>
                                    {item.title === "Applications" && <p>{item.description}</p>}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </>
                      </InfiniteScroll>
                    ) : (
                      <NoDataFound headText="No Data found" />
                    )}
                  </div>

                </div>
              </section>
              :
              <>
               <button className="normalbtn d-flex align-items-center">  
                   <SimCheckBox checked={checkBoxAll[activeTab]} onChange={(e) => handleSelectCheckbox(type, checkBoxAll[activeTab])} />
                    Select All
               </button>

               <ResourceTabComponent handleCheckboxChange={handleCheckboxChange} id_link={id_link} type={type} selectedResource={selectedResource} hasMore={hasMore} loadMoreData={loadMoreData} activeTab={activeTab} list={list} />
              
               </>
               }
            </>
          );
        })}
      </div>
    </>
  );
};

export default ResourceSection;